import React from 'react';
import { withStyles } from '@mui/styles';
import Slide from '@mui/material/Slide';
import PropTypes from 'prop-types';
import Dialog from '@mui/material/Dialog';

const paperScrollBody = {
    marginTop: 80,
    width: 1000,
    padding: '30px 0',
    backgroundColor: '#E2E8F0',
    verticalAlign: 'top',
};

const styles = () => ({
    scrollPaper: {
        alignItems: 'flex-start',
    },
    paperScrollBody,
    paperScrollBodyNoPadding: {
        ...paperScrollBody,
        padding: 0,
        width: 450,
        verticalAlign: 'top',
    },
    backdropRoot: {
        background: 'rgba(0,0,0,0.8)',
    },
    paperRoot: {
        borderRadius: 3,
    },
});

const SingularDialog = ({
    open = false,
    children = null,
    classes = {},
    noPadding = false,
    className = '',
    onEscapePress = null,
    onClose = () => {},
}) => {
    const handleClose = (event, reason) => {
        if (reason === 'escapeKeyDown' && onEscapePress) {
            onEscapePress();
        } else {
            onClose();
        }
    };

    const { backdropRoot, paperRoot, ...mainClasses } = classes;
    const finalClasses = { ...mainClasses };
    // ugly hack until we upgrade mui's version which support conditional styling
    if (noPadding) {
        finalClasses.paperScrollBody = finalClasses.paperScrollBodyNoPadding;
    }
    delete finalClasses.paperScrollBodyNoPadding;
    if (className) {
        finalClasses.paperScrollBody = `${finalClasses.paperScrollBody} ${className}`;
    }

    return (
        <Dialog
            open={open}
            maxWidth={false}
            classes={finalClasses}
            TransitionComponent={Slide}
            scroll="body"
            BackdropProps={{
                classes: {
                    root: backdropRoot,
                },
            }}
            PaperProps={{
                classes: {
                    root: paperRoot,
                },
            }}
            onClose={handleClose}
        >
            {children}
        </Dialog>
    );
};

SingularDialog.propTypes = {
    open: PropTypes.bool,
    children: PropTypes.node,
    classes: PropTypes.objectOf(PropTypes.any),
    noPadding: PropTypes.bool,
    className: PropTypes.string,
    onEscapePress: PropTypes.func,
    onClose: PropTypes.func,
};

export default withStyles(styles)(SingularDialog);
